export default __webpack_public_path__ + "static/media/dashboard-2.6cf0c0de.svg";